export default function appState(state = {}, action) {
    switch (action.type) {
        case "UPDATE":
            return Object.assign({}, state, {
                updated: new Date().getTime()
            }, action.payload || { });
        default:
            return state;
    }
}
